export const DB_PREFIX_REFERENCES = 'references';
export const DB_PREFIX_REFEREES = 'referees';
export const TITLE = 'References & Referees';
export const DESCRIPTION = '';
